
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import WhatsAppButton from '../../../components/feature/WhatsAppButton';
import EcoPilot from '../../../components/feature/EcoPilot';
import { useState } from 'react';
import Button from '../../../components/base/Button';
import Card from '../../../components/base/Card';
import QuoteModal from '../../../components/feature/QuoteModal';

export default function GRIPage() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  return (
    <>
      <Header />
      <main className="min-h-screen">
        {/* Hero Section */}
        <section 
          className="relative py-32 bg-cover bg-center"
          style={{ 
            backgroundImage: 'url(https://readdy.ai/api/search-image?query=Professional%20GRI%20sustainability%20reporting%20team%20preparing%20Global%20Reporting%20Initiative%20standards%20documentation%20in%20modern%20corporate%20office%20environment%20with%20charts%20and%20sustainability%20metrics%20on%20screens&width=1200&height=600&seq=601&orientation=landscape)' 
          }}
        >
          <div className="absolute inset-0 bg-emerald-900/80"></div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl">
              <h1 className="text-5xl font-bold text-white mb-6 animate-in fade-in slide-in-from-bottom-8 duration-1000">
                GRI Sürdürülebilirlik Raporu
              </h1>
              <p className="text-xl text-emerald-100 mb-8 leading-relaxed animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300">
                Global Reporting Initiative standartlarına uygun sürdürülebilirlik raporları ile şirketinizi uluslararası arenada öne çıkarın. 16+ yıllık deneyimimizle profesyonel GRI raporlama hizmetleri sunuyoruz.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-500">
                <Button 
                  size="lg"
                  onClick={() => setIsQuoteModalOpen(true)}
                  className="whitespace-nowrap"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-file-text-line"></i>
                  </div>
                  Teklif Al
                </Button>
                <Button 
                  size="lg" 
                  variant="outline"
                  onClick={() => window.open('https://calendly.com/ecoventra', '_blank')}
                  className="border-white text-white hover:bg-white hover:text-emerald-700 whitespace-nowrap"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-calendar-line"></i>
                  </div>
                  Ücretsiz Konsültasyon
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* Key Features */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                GRI Raporlama Hizmetlerimiz
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Uluslararası standartlarda sürdürülebilirlik raporlaması için kapsamlı hizmetler
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  icon: 'ri-book-open-line',
                  title: 'GRI Universal Standards',
                  description: 'GRI 2021 güncel standartlarına tam uyumluluk'
                },
                {
                  icon: 'ri-search-line',
                  title: 'Materializasyon Analizi',
                  description: 'Stakeholder beklentileri ve işletme etkilerinin analizi'
                },
                {
                  icon: 'ri-team-line',
                  title: 'Stakeholder Katılımı',
                  description: 'Paydaş görüşlerinin raporlama sürecine entegrasyonu'
                },
                {
                  icon: 'ri-shield-check-line',
                  title: 'Bağımsız Doğrulama',
                  description: 'Üçüncü taraf doğrulama süreçlerinde destek'
                }
              ].map((feature, index) => (
                <Card key={index} className="p-6 text-center hover:shadow-lg transition-shadow duration-300">
                  <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${feature.icon} text-2xl text-emerald-600`}></i>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
                  <p className="text-gray-600 text-sm">{feature.description}</p>
                </Card>
              ))}
            </div>
          </div>
        </section>

        {/* Process */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                GRI Raporlama Sürecimiz
              </h2>
              <p className="text-xl text-gray-600">
                12-16 haftalık kapsamlı raporlama süreci
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  step: '1',
                  title: 'İlk Değerlendirme',
                  description: 'Mevcut durum analizi ve hedef belirleme',
                  duration: '1-2 hafta'
                },
                {
                  step: '2',
                  title: 'Materializasyon',
                  description: 'Stakeholder katılımı ve önemlilik analizi',
                  duration: '2-3 hafta'
                },
                {
                  step: '3',
                  title: 'Veri Toplama',
                  description: 'GRI göstergelerine uygun veri derleme',
                  duration: '4-6 hafta'
                },
                {
                  step: '4',
                  title: 'Rapor Hazırlama',
                  description: 'GRI standartlarında rapor yazımı ve doğrulama',
                  duration: '5-5 hafta'
                }
              ].map((process, index) => (
                <div key={index} className="relative">
                  <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                    <div className="flex items-center mb-4">
                      <div className="w-12 h-12 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4">
                        {process.step}
                      </div>
                      <div className="text-sm text-emerald-600 font-medium">{process.duration}</div>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{process.title}</h3>
                    <p className="text-gray-600 text-sm">{process.description}</p>
                  </div>
                  {index < 3 && (
                    <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                      <i className="ri-arrow-right-line text-2xl text-emerald-300"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6">
                  GRI Raporlamasının Faydaları
                </h2>
                <div className="space-y-6">
                  {[
                    {
                      icon: 'ri-global-line',
                      title: 'Uluslararası Tanınırlık',
                      description: 'Dünya çapında kabul görmüş standartlarla güvenilirlik'
                    },
                    {
                      icon: 'ri-eye-line',
                      title: 'Şeffaflık ve Hesap Verebilirlik',
                      description: 'Paydaşlara karşı şeffaf ve hesap verebilir yönetim'
                    },
                    {
                      icon: 'ri-funds-line',
                      title: 'Yatırımcı İlgisi',
                      description: 'ESG odaklı yatırımcılar için cazip yatırım fırsatı'
                    },
                    {
                      icon: 'ri-award-line',
                      title: 'Rekabet Avantajı',
                      description: 'Sürdürülebilirlik liderliği ile pazar avantajı'
                    }
                  ].map((benefit, index) => (
                    <div key={index} className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className={`${benefit.icon} text-xl text-emerald-600`}></i>
                      </div>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-1">{benefit.title}</h3>
                        <p className="text-gray-600">{benefit.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20business%20team%20celebrating%20GRI%20sustainability%20report%20success%20with%20international%20recognition%20awards%20and%20certificates%20in%20modern%20corporate%20office%20environment&width=600&height=400&seq=602&orientation=landscape"
                  alt="GRI Raporlama Faydaları"
                  className="rounded-2xl shadow-2xl"
                />
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-emerald-600">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              GRI Sürdürülebilirlik Raporunuz İçin Başlayın
            </h2>
            <p className="text-xl text-emerald-100 mb-10">
              Uzman ekibimizle ücretsiz konsültasyon alın ve projenizi başlatın
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                size="lg"
                onClick={() => setIsQuoteModalOpen(true)}
                className="bg-white text-emerald-600 hover:bg-gray-100 whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-file-text-line"></i>
                </div>
                Detaylı Teklif Al
              </Button>
              <Button 
                size="lg" 
                variant="outline"
                onClick={() => window.open('https://api.whatsapp.com/send?phone=905326230183&text=Merhaba, GRI sürdürülebilirlik raporu hakkında bilgi almak istiyorum.', '_blank')}
                className="border-white text-white hover:bg-white hover:text-emerald-600 whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-whatsapp-line"></i>
                </div>
                WhatsApp ile İletişim
              </Button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
      <EcoPilot />
      
      <QuoteModal 
        isOpen={isQuoteModalOpen} 
        onClose={() => setIsQuoteModalOpen(false)} 
      />
    </>
  );
}
